import { render } from "./MachineShow.vue?vue&type=template&id=3ddcf6fa&ts=true"
import script from "./MachineShow.vue?vue&type=script&lang=ts"
export * from "./MachineShow.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src669166032/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__